import { sendUserLog, sendCtmEvtLog, UserLog } from '@/utils/log'

export default  {
    building_id: '',
    building_name: '',
    play_url: '',
    play_seconds: 0,
    countdown_task: 0,
    log ()  {
        console.error(this.play_url, this.play_seconds)
        UserLog.buildingAudios(this.building_id, {
            building_name: this.building_name, 
            audio_url: this.play_url,
            play_seconds: this.play_seconds
        })
        sendCtmEvtLog('楼盘户型讲解')
        sendUserLog('fc_layout_audio', {
            d_key: this.play_url,
            d_paras: this.play_seconds,
            d_event: 1
        })
    },
    play (url, { building_id, building_name }) {
        this.play_url = url
        this.play_seconds = 0
        this.building_id = building_id
        this.building_name = building_name

        this.countdown_task && clearTimeout(this.countdown_task)
        this._runCountdown()
    },
    _runCountdown () {
        this.countdown_task = setTimeout(() => {
            this.play_seconds++
            this._runCountdown()
        }, 1000)
    },
    stop () {
        this.log()
        this.countdown_task && clearTimeout(this.countdown_task)
        this.play_seconds = 0
    }
}